const types = {
  GENERAL: 'general',
  SPECIALIST: 'specialist',
  PSYCHOLOGIST: 'psychologist',
  PSYCHIATRIST: 'psychiatrist',
  ANY_PHYSICAL: 'any_physical',
  ANY_MENTAL: 'any_mental',
  CATEGORY_PHYSICAL: 'physical',
  CATEGORY_MENTAL: 'mental',
  PHYSICAL_TYPES_ARRAY: ['general', 'specialist'],
  MENTAL_TYPES_ARRAY: ['psychologist', 'psychiatrist'],
};

export default types;
